import { render, staticRenderFns } from "./CenterItem.vue?vue&type=template&id=f20ff6ac"
import script from "./CenterItem.vue?vue&type=script&lang=js"
export * from "./CenterItem.vue?vue&type=script&lang=js"
import style0 from "./CenterItem.vue?vue&type=style&index=0&id=f20ff6ac&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports